/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Whitelabel } from './Whitelabel';
export type AsafBoxUser = {
  id?: string;
  name?: string;
  username?: string;
  disabled?: boolean;
  priority?: number;
  role?: AsafBoxUser.role;
  profileImage?: string;
  arboxUserId?: string;
  whitelabels?: Array<Whitelabel>;
  createdAt?: string;
  updatedAt?: string;
};
export namespace AsafBoxUser {
  export enum role {
    ADMIN = 'ADMIN',
    USER = 'USER',
  }
}

